import { ComboBox } from "../../../common/utils/combobox";
import { Archivo } from "./util_entity";

export class Tracking {
    constructor(
        public Codigo?: number,
        public CodigoTitular?: number,
        public NombreTitular?: string,
        public Ramo?: string,
        public CodigoAseguradora?: number,
        public Aseguradora?: string,
        public Poliza?: string,
        public Paciente?: string,
        public CodigoDiagnostico?: number,
        public NombreDiagnostico?: string,
        public Estado?: number,
        public DiasTramite?: number,
        public ValorPresentado?: number,
        public CartaAseguradora?: number,
        public CartaDocumentosPendientes?: number,
        public Observaciones?: string,
        public FechaCreacion?: Date,
        public FechaPago?: Date,
        public Archivos?: ArchivosPreautorizaciones[],
        public ArchivoAdjunto?: Archivo,
        public FechaCierre?: Date,
        public CodigoCliente?: number,
        public NombreCliente?: string,
        public Grupo?: number,
        public RolEjecutivo?: number,
        public CedulaTitular?: string,
        public CodigoCiudad?: number,
        public Seleccionado?: boolean,
        public NombreEstado?: string,
        public Tipo?: number,
        public ValorPagado?: number,
        public NombreClinica?: string,
        public FechaProgramada?: Date,
        public NombreContacto?: string,
        public EmailContacto?: string,
        public NumSiniestroAse?: string,
        public NombreTipo?: string,
        public ValorCubierto?: number,
        public ValorNoCubierto?: number,
        public ValorNotaCobranza?: number,
        public NumeroLiquidacion?: number,
        public ObservacionNegacion?: string,
        public NombreNuevoDiagnostico?: string,
        public CodigoPlanPaciente?: number,
        public FechaHasta?: Date,
        public CodigoUnidad?: number,
        public NombreArchivo?: string,
        public CodigoGrupo?: number,
        public CorreoTitular?: string,
        public Telefono?: string,
        public CorreoCopia?: string,
        public NotFIngles?: boolean,
        public CodigoDependiente?: number,
        public CedulaDependiente?: string


    ) { }

};
export class ArchivosPreautorizaciones {
    constructor(
        public CodigoArchivo?: number,
        public NombreArchivo?: string
    ) {
    }
};
export class CartaSiniestros {
    constructor(
        public Contacto?: string,
        public CodigoAseguradora?: number,
        public CodigoCiudad?: number,
        public Observaciones?: string,
        public NombreCliente?: string,
        public RolEmpleado?: number,
        public CodigoUnidad?: number,
        public CodigoCliente?: number,
        public Siniestros?: Tracking[],
        public EnviarCorreo?: boolean,
        public EmailContacto?: string,
        public CodigoGrupo?: number,
        public EmailComparativo?: string,
        public EmailEjecutivo?: string,
        public ApellidosNombresEjecutivo?: string,
        public CodigoCarta?: number,
    ) {
    }
};
export class CartaPreautorizacion {
    constructor(
        public CodigoCiudad?: number,
        public CodigoCarta?: string,
        public NombreCliente?: string,
        public NumeroCarta?: number,
        public RolEmpleado?: number,
        public CodigoUnidad?: number,
        public NombreTitular?: string,
        public Paciente?: string,
        public NombreClinica?: string,
        public Diagnostico?: string,
        public Estado?: number,
        public CodigoCliente?: number,
        public CodigoPreautorizacion?: number,
        public Observacion?: string
    ) {
    }
};

export class ConsultaTracking {
    constructor(
        public CodigoCiudad?: number,
        public CodigoCliente?: number,
        public CodigoGrupo?: number,
        public CodigoTitular?: number,
        public CodigoAseguradora?: number,
        public CodigoRamo?: number,
        public TipoFecha?: number,
        public FechaDesde?: Date,
        public FechaHasta?: Date,
        public TipoGestion?: number,
        public RolEmpleado?: number,
        public Estado?: number,
        public TipoConsulta?: number,
        public Unidad?: number,
        public NumeroSinAseguradora?: string,
        public EmailContacto?: string,
    ) {
    }
};
export class CartaNotaCobranza {
    constructor(
        public Contacto?: string,
        public CodigoAseguradora?: number,
        public CodigoCiudad?: number,
        public Observaciones?: string,
        public NombreCliente?: string,
        public RolEmpleado?: number,
        public CodigoUnidad?: number,
        public CodigoCliente?: number,
        public NotaCobranza?: Tracking[]
    ) {
    }
};


export class PantallaConsultaTracking {
    constructor(
        public Clientes?: ComboBox[],
        public ClientesGrupo?: ComboBox[],
        public Grupos?: ComboBox[],
        public Ejecutivos?: ComboBox[],
        public Aseguradoras?: ComboBox[]
    ) {
    }
};

export class EstadisticoTracking {
    constructor(
        public Ramo?: string,
        public CodigoAseguradora?: number,
        public Aseguradora?: string,
        public Poliza?: string,
        public CodigoCliente?: number,
        public NombreCliente?: string,
        public Tipo?: number,
        public NumeroSiniestros?: number,
        public TiempoPromedio?: number,
        public Ejecutivo?: string,
        public NombreTipo?: string
    ) {

    }
};

export class PolizaTracking {
    constructor(
        public Poliza?: string,
        public Pacientes?: ComboBox[]
    ) { }

};

export class RamoTracking {
    constructor(
        public Ramo?: string,
        public Polizas?: PolizaTracking[]
    ) { }

};

export class NuevoTracking {
    constructor(
        public NombreAseguradora?: string,
        public CodigoAseguradora?: number,
        public NombreRamo?: string,
        public Ramos?: RamoTracking[]
    ) { }

};
export class ArchivoSiniestrosPagados {
    constructor(
        public CodigoArchivo?: number,
        public NombreArchivo?: string
    ) {
    }
};
export class ObjEnvioCorreoTracking {
    constructor(
        public ListaTracking?: Tracking[],
        public CorreoAlterno?: string
    ) {
    }
};


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/components/common/utils/entities/tracking-siniestros.ts